import {
  useEffect,
  useState
} from 'react';

import {
  fetchProperties,
  deleteProperty
} from  '../services/propertyService' ;

export const useProperties = () => {

  const [properties, setProperties] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState(null);

  useEffect(() => {

    loadProperties();

  }, []);

  const loadProperties = async () => {

    try {

      setLoading(true);

      const data = await fetchProperties();

      setProperties(data);

    } catch (err) {

      setError(err.message);

    } finally {

      setLoading(false);
    }
  };

  const removeProperty = async (
    propertyId
  ) => {

    try {

      await deleteProperty(propertyId);

      setProperties((prev) =>
        prev.filter(
          (item) => item.id !== propertyId
        )
      );

    } catch (err) {

    }
  };

  return {
    properties,
    loading,
    error,
    removeProperty,
    reload: loadProperties
  };
};